import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppUser } from 'src/app/models/appUser.model';
import { AppSettingsService } from '../app-settings/app-settings.service';
import { StorageService } from '../storage/storage.service';
import { Preferences } from '@capacitor/preferences';

@Injectable({
  providedIn: 'root'
})
export class CompanionService {
  constructor(
    private http: HttpClient,
    private storage: StorageService,
    private settings: AppSettingsService
  ) { }

  getCompanionsForAppUser(appUserID: number): Observable<AppUser[]> {
    const url = this.settings.apiUrl + `appUser/companions`;

    return this.http.get(url).pipe(
      map((data: any[]) => {
        let companions: AppUser[] = [];
        if(data) {
          data.forEach((companionAppUser) => {
            companions.push(new AppUser(companionAppUser));
          });
        }
        return companions;
      })
    );
  }

  getPendingCompanionsForAppUser(): Observable<AppUser[]> {
    const url = this.settings.apiUrl + `appUser/pendingCompanions`;

    return this.http.get(url).pipe(
      map((data: any[]) => {
        let pendingCompanions: AppUser[] = [];
        if(data) {
          data.forEach((pending) => {
            pendingCompanions.push(new AppUser(pending));
          });
        }
        return pendingCompanions;
      })
    );
  }

  getChildrenForAppUser(portalID?: number): Observable<AppUser[]> {
    let params = {
      get_children: true,
      portal_id: null
    }

    if (portalID) {
      params.portal_id = portalID;
    }

    const url = this.settings.apiUrl + `appUser/companions?parameters=` + JSON.stringify(params);

    return this.http.get(url).pipe(
      map((data: any[]) => {
        let companions: AppUser[] = [];
        if(data) {
          data.forEach((companionAppUser) => {
            companions.push(new AppUser(companionAppUser));
          });
        }
        return companions;
      })
    );
  }

  acceptCompanion(appUserID: number) {
    const url = this.settings.apiUrl + `appUser/companions/${appUserID}/accept`;

    return this.http.put(url, {}).pipe(
      map(() => {
        return true;
      })
    );
  }

  rejectCompanion(appUserID: number) {
    const url = this.settings.apiUrl + `appUser/companions/${appUserID}/reject`;

    return this.http.put(url, {}).pipe(
      map(() => {
        return true;
      })
    );
  }

  addCompanionAppUser(appUserID: number, companionEmail: string, portalID?: number): Observable<AppUser> {
    let body = {
      companion_email: companionEmail,
      portal_id: null
    }

    if (portalID) {
      body.portal_id = portalID;
    }

    const url = this.settings.apiUrl + `appUser/companions`;

    return this.http.post(url, body).pipe(
      map((data: AppUser) => {
        return new AppUser(data);
      })
    );
  }

  deleteCompanionAppUser(appUserID: number): Observable<boolean> {
    const url = this.settings.apiUrl + `appUser/companions/${appUserID}`;

    return this.http.delete(url).pipe(
      map(() => {
        return true;
      })
    );
  }

  signIntoCompanionAppUser(companionAppUserID: number, deviceID: string): Observable<string> {
    const params = {
      device_id: deviceID
    }

    const url = this.settings.apiUrl + `appUser/login/${companionAppUserID}?parameters=` + JSON.stringify(params);

    return this.http.get(url).pipe(
      map((data: any) => {
        this.storage.set("Session_Token", data);
        Preferences.set({
          key: 'Session_Token',
          value: data,
        });
        return data;
      })
    );
  }
}
